import React, { Component } from 'react';
import Select from 'components/TeacherSelect';
import { connect } from 'react-redux';
import './style.css';

class Languages extends Component {
  render() {
    const {
      onAdd, onChange, onRemove, services, skillLevels
    } = this.props;

    const languages = services.filter(item => item.categoryId === 1);

    return (
      <div className="teacher-settings-profile__section teacher-profile-languages mb-4 p-4 p-md-4 p-lg-5">
        <div className="teacher-profile-languages__content">
          <h4 className="mb-4">Languages you speak</h4>

          {this.props.languages.map((language, index) => (
            <div key={index} className="teacher-profile-languages__item row">
              <div className="col col-6">
                <Select
                  name="serviceId"
                  options={languages}
                  value={language.serviceId}
                  onChange={(field, value) => onChange(index, field, value)}
                />
              </div>
              <div className="col col-6">
                <Select
                  name="skillLevelId"
                  options={skillLevels}
                  value={language.skillLevelId}
                  onChange={(field, value) => onChange(index, field, value)}
                />
              </div>
              {index > 0 && (
                <div
                  className="teacher-profile-languages__item-close btn-cursor"
                  onClick={() => onRemove(index)}
                />
              )}
            </div>
          ))}
          <div className="teacher-profile-languages__add btn-cursor mt-3" onClick={onAdd}>
            Add language
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    services: state.meta.services,
    skillLevels: state.meta.skillLevels
  };
}

export default connect(mapStateToProps)(Languages);



// WEBPACK FOOTER //
// ./src/pages/teacher/Settings/Profile/Languages/index.js